import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { GlobalConstants } from "../../global-constants";
import { PlatformService } from "../platform/platform.service";
import { Page } from "@src/app/models/interfaces/page.interface";

@Injectable({
  providedIn: "root",
})
export class PageService {
  private readonly API_URL: string;
  private readonly constantesGlobales: any;
  private readonly isCartaEditorial = new BehaviorSubject<boolean | null>(null);
  public isCartaEditorial$: Observable<boolean> = this.isCartaEditorial.asObservable();
  constructor(
    private readonly httpClient: HttpClient,
    private readonly platformService: PlatformService,
  ) {
    const host = this.platformService.getLocationHostname();
    this.constantesGlobales = new GlobalConstants(host);
    this.API_URL = this.constantesGlobales.urlApi;
  }

  /**
   * Método para obtener las páginas desde la API utilizando un slug específico.
   *
   * @param {string} slug - Identificador único de la página que se desea obtener.
   * @returns {Observable<Page>} Observable que emite los datos de la página obtenidos desde la API.
   *
   * @description
   * Este método realiza una solicitud HTTP GET a la API para obtener información
   * de las páginas asociadas al slug proporcionado. Los encabezados de la solicitud
   * incluyen el tipo de contenido y los formatos aceptados. En caso de éxito, el observable
   * emite los datos recibidos y se completa. Si ocurre un error, este se registra en la consola
   * y se emite a través del observable.
   */
  public getPages(slug: string): Observable<Page> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json, text/javascript, */*; q=0.01",
    });

    const body = new HttpParams().set("slug", slug);

    return new Observable<Page>((observer) => {
      this.httpClient.get<Page>(this.API_URL + "/getPages", { headers: headers, params: body }).subscribe({
        next: (data) => {
          observer.next(data);
          observer.complete();
        },
        error: (error) => {
          observer.error(error);
        },
      });
    });
  }
}
